import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { resetPassword } from 'liyu-pc-base/api/permission/user-manage';
import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
import { Record, SearchConfig } from 'liyu-pc-base/components/remotePages/typing';
import { event_obj, useUserStore } from 'liyu-pc-base/init-plugin';
import { TableColumn } from 'liyu-pc-base/typing';
import { createVNode, reactive } from 'vue';
import { config } from './permission-user-config';
export default () => {
  const userStore = useUserStore();
  const curr_person_manage_type = userStore.person.manage_type;
  const current_org = userStore.currentOrg; // 当前组织org
  const current_person = userStore.person;
  let manage_type_options = [];
  if (curr_person_manage_type === 2) {
    manage_type_options = [
      { label: '普通用户', value: 0 },
      { label: '管理员', value: 1 },
      { label: '超级管理员', value: 2 },
    ];
  } else if (curr_person_manage_type === 1) {
    manage_type_options = [
      { label: '普通用户', value: 0 },
      { label: '管理员', value: 1 },
    ];
  } else if (curr_person_manage_type === 0) {
    manage_type_options = [{ label: '普通用户', value: 0 }];
  }
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'remoteselect',
        name: 'aim_org_id',
        label: '目标组织',
        disabled: false,
        placeholder: '请选择目标组织',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        labelKey: 'name',
        valueKey: 'id',
        modalType: 'sys-query_org_for_login_list',
      },
      {
        type: 'input',
        name: 'name',
        label: '名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填写用户名称',
      },
      {
        type: 'select',
        name: 'manage_type',
        label: '用户类型',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填姓名',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org.id,
      aim_org_id: current_org.id,
      is_active: true,
      name: '',
      manage_type: null,
      get_role: true,
    }),
    options: {
      manage_type: manage_type_options,
    },
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [
      {
        type: 'remoteselect',
        name: 'aim_org_id',
        label: '隶属组织',
        disabled: false,
        allowClear: true,
        labelKey: 'name',
        valueKey: 'id',
        placeholder: '请选择隶属组织',
        datasourceType: 'remote',
        mode: 'default',
        default: true,
        modalType: 'select-org-id',
      },
      {
        type: 'input',
        name: 'username',
        label: '手机号',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填手机号',
      },
      {
        type: 'input',
        name: 'realname',
        label: '姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填姓名',
      },
      {
        type: 'select',
        name: 'manage_type',
        label: '用户类型',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        maxlength: 100,
        defaultValue: '',
        placeholder: '请填姓名',
      },
      {
        type: 'remoteselect',
        name: 'role_ids',
        label: '角色',
        disabled: false,
        placeholder: '请选择角色',
        datasourceType: 'remote',
        mode: 'multiple',
        allowClear: true,
        modalType: 'liyu_permission-role',
      },
    ],
    rules: {
      username: [{ required: true, pattern: /^1[123456789]\d{9}$/, message: '请输入正确手机号' }],
      realname: [{ required: true, message: '请输入姓名' }],
    },
    model: {
      org_id: current_org?.id,
      id: null,
      username: '',
      realname: '',
      manage_type: 1,
      aim_org_id: current_org?.id,
    },
    options: {
      manage_type: manage_type_options,
    },
  };

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org.id,
      id: null,
      username: '',
      realname: '',
      title: '',
      aim_org_id: '',
      email: '',
    }),
    options: {},
  };

  const titleList = {
    title: '用户管理',
    addModalTitle: '新建用户',
    updateTitle: '修改',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: true, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      aim_org_id: 'org_id',
      person_id: 'id',
    },
    delete: {
      person_id: 'id',
    },
    recover: {
      person_id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      person_id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      width: 50,
      dataIndex: 'index',
      checked: true,
      fixed: 'left',
    },
    {
      title: '名称',
      width: 150,
      dataIndex: 'realname',
      checked: true,
      fixed: 'left',
      resizable: true,
    },
    {
      title: '用户类型',
      width: 120,
      dataIndex: 'manage_type',
      checked: true,
      cellComponent: 'tag',
      contentMap: {
        0: '普通用户',
        1: '管理员',
        2: '超级管理员',
      },
      colorMap: {
        0: '',
        2: 'cyan',
      },
      resizable: true,
    },
    {
      title: '账号',
      width: 130,
      checked: true,
      dataIndex: 'user__username',
      resizable: true,
    },
    {
      title: '角色',
      minWidth: 200,
      checked: true,
      dataIndex: 'role_list',
      cellComponent: 'list',
      resizable: true,
    },
    // {
    //   title: '电子邮箱',
    //   width: 150,
    //   dataIndex: 'email',
    // },
    // {
    //   title: '微信',
    //   width: 80,
    //   dataIndex: 'user__lyuserinfo__wechat_username',
    //   cellComponent: 'tag',
    //   color: (record: any, text: any) => {
    //     return text ? 'green' : 'red';
    //   },
    //   content: (record: any, text: any) => {
    //     return text ? '已绑定' : '未绑定';
    //   },
    // },
    // {
    //   title: '隶属部门',
    //   minWidth: 200,
    //   dataIndex: 'group_list',
    //   cellComponent: 'list',
    // },
    // {
    //   title: '职务',
    //   width: 150,
    //   dataIndex: 'title',
    // },
    {
      title: '是否可用',
      width: 100,
      dataIndex: 'is_active',
      checked: true,
      resizable: true,
      cellComponent: 'boolean',
      name1: '可用',
      name2: '禁用',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '可用', value: 'true' },
        { text: '禁用', value: 'false' },
      ],
    },
    {
      title: '操作',
      width: 50,
      checked: true,
      dataIndex: 'action',
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const btn_list: BtnListConfig = [
    {
      name: '修改',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      authority: 'sys/update_user',
      urls: ['sys/update_user'],
      model_config: {
        title: '修改用户',
        component: 'userConfig',
        init_data: {
          form_type: 'edit',
        },
      },
    },
    {
      name: '重置密码',
      clazz: 'primary',
      authority: 'sys/reset_password',
      urls: ['sys/reset_password'],
      cb: ({ record }) => {
        Modal.confirm({
          title: '温馨提示',
          content: '是否重置 [' + record.realname + '] 的密码？',
          icon: () => createVNode(ExclamationCircleOutlined),
          okText: '确定',
          onOk() {
            return new Promise(resolve => {
              resetPassword({
                org_id: record.org_id,
                username: record.user__username,
              })
                .then(() => {
                  message.success('重置密码成功');
                })
                .finally(() => {
                  resolve(null);
                });
            }).catch(() => console.log('Oops errors!'));
          },
          onCancel() {},
        });
      },
    },
  ];
  const head_btn_list: HeadBtnListConfig = [
    {
      name: '新建用户',
      model_kind: 'custom_component',
      type: 'dropdown',
      is_show: true,
      clazz: 'primary',
      authority: 'sys/create_user',
      urls: ['sys/create_user'],
      model_config: {
        title: '新建用户',
        component: 'userConfig',
        init_data: {
          form_type: 'create',
        },
      },
    },
  ];
  if ([1, 2].includes(current_person.manage_type)) {
    head_btn_list.push({
      name: '批量创建用户',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '批量创建用户',
        component: 'batchCreateUser',
      },
    });
  }
  return {
    searchConfig: search_config,
    formModalConfig: edit_model_config,
    updateFormModalConfig: update_model_config,
    queryData: '/sys/query_person_detail_list',
    addData: '/sys/create_user',
    updateData: '/sys/update_user',
    removeData: '/sys/delete_user',
    recoverData: '/sys/recover_user',
    baseColumns: baseColumns,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj(),
    base_search_condition_config_list: [],
    default_search_condition_config_list: [[]],
    condition_group_config_list: [],
    is_show_advantage: false,
    is_show_normal_search: true,
    is_only_show_advantage: false,
    is_only_show_normal_search: true,
    queryConditionGroupData: null,
    isView: false,
  };
};
